import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }

  /**
   * Description: Método que llama el servicio web que valida si la sesión sigue activa en el backend
   * Se usa destrcuturación de objetos en los parametros ya que llega como un objeto desde el componente
   * Autor: Julian Ciro
   * @param documentId cédula del usuario
   * @param token token de la sesión actual
   * @return Mensaje de confirmación del estado de la sesión
   */
  validateSessionUserLogged({documentId, token}) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_IS_LOGGED, { documentId, token });
  }


}
